"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _formatting = require("@staccx/formatting");

var _themeContants = require("../../../constants/themeContants");

var _theming = require("../../../theming");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var KeyFigures = function KeyFigures(_ref) {
  var figures = _ref.figures,
      variant = _ref.variant;
  return _react["default"].createElement(List, {
    variant: variant
  }, figures.map(function (figure) {
    return _react["default"].createElement(ListItem, {
      key: figure.key,
      variant: variant
    }, _react["default"].createElement(Heading, {
      variant: variant
    }, figure.label), _react["default"].createElement(Value, {
      variant: variant
    }, " ", (0, _formatting.formatCurrency)(figure.amount)));
  }));
};

KeyFigures.themeProps = {
  list: {
    name: "KEYFIGURES",
    description: "list style",
    type: _themeContants.themePropTypes.style
  },
  item: {
    name: "KEYFIGURES_ITEM",
    description: "item style",
    type: _themeContants.themePropTypes.style
  },
  heading: {
    name: "KEYFIGURES_HEADING",
    description: "heading style",
    type: _themeContants.themePropTypes.style
  },
  value: {
    name: "KEYFIGURES_VALUE",
    description: "value style",
    type: _themeContants.themePropTypes.style
  }
};

var List = _styledComponents["default"].ul.withConfig({
  displayName: "Keyfigures__List",
  componentId: "sc-10iyuer-0"
})(["display:flex;flex-wrap:wrap;justify-content:center;margin-bottom:0;color:currentColor;padding:0;", ";"], (0, _theming.applyVariants)(KeyFigures.themeProps.list.name));

var ListItem = _styledComponents["default"].li.withConfig({
  displayName: "Keyfigures__ListItem",
  componentId: "sc-10iyuer-1"
})(["position:relative;display:flex;padding:", " ", ";flex-direction:column;text-align:center;&:not(:first-child)::after{content:\"\";position:absolute;left:0;top:0;height:100%;width:1px;background-color:", ";}", ";"], _theming.spacing.tiny, _theming.spacing.medium, _theming.color.line, (0, _theming.applyVariants)(KeyFigures.themeProps.item.name));

var Heading = _styledComponents["default"].h3.withConfig({
  displayName: "Keyfigures__Heading",
  componentId: "sc-10iyuer-2"
})(["padding-bottom:", ";", ";"], _theming.spacing.tiny, (0, _theming.applyVariants)(KeyFigures.themeProps.heading.name));

var Value = _styledComponents["default"].span.withConfig({
  displayName: "Keyfigures__Value",
  componentId: "sc-10iyuer-3"
})(["font-size:", ";color:", ";", ";"], _theming.font.h2, _theming.color.blue, (0, _theming.applyVariants)(KeyFigures.themeProps.value.name));

KeyFigures.propTypes = {
  figures: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    value: _propTypes["default"].string,
    heading: _propTypes["default"].string
  })).isRequired
};
var _default = KeyFigures;
exports["default"] = _default;